var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-tag-row flex"},_vm._l((_vm.row),function(tag,index){return _c('div',{key:index,staticClass:"bg-caramel-tertiary-900",class:index ? 'tag cell-size' : 'cell-size'},[_vm._v(" "+_vm._s(_vm.$t(tag))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }